'use client';

import { useEffect } from 'react';
import DallasStack from '../Dallas/Stack/DallasStack';
import DallasText from '../Dallas/Text/DallasText';
import TruckSmarterAppIcon from '../Dallas/Images/TruckSmarterAppIcon/TruckSmarterAppIcon';
import useTrackAnalyticsEventTruckSmarterAppUpsell from '../../_lib/analytics/useTrackAnalyticsEventTruckSmarterAppUpsell';
import BRANCH_LINK from './branch-link';

import styles from './TruckSmarterAppUpsellBanner.module.scss';

export default function TruckSmarterAppUpsellBanner() {
  const track = useTrackAnalyticsEventTruckSmarterAppUpsell();

  useEffect(() => {
    track({
      type: 'APP_UPSELL_BANNER_RENDERED',
      metadata: {},
    });
  }, [track]);

  return (
    <DallasStack
      className={styles.root}
      direction="row"
      gap="sm"
      paddingVertical="sm"
      paddingHorizontal="md"
      data-get-app-banner
      alignVertical="center"
    >
      <TruckSmarterAppIcon width={40} />
      <DallasStack direction="row" gap="lg" alignVertical="center" flex>
        <DallasText variant="captionL" color="light">
          Use the TruckSmarter App for the best mobile experience
        </DallasText>
        <a
          className={styles.linkButton}
          href={BRANCH_LINK}
          onClick={() =>
            track({
              type: 'APP_UPSELL_BANNER_CTA_PRESSED',
              metadata: {},
            })
          }
        >
          USE APP
        </a>
      </DallasStack>
    </DallasStack>
  );
}
